<template>
    <div class="detail-layout">
        <CampaignPicture class="detail-layout__picture"
            :imgClass="'default'"
            :campaignImage="detailController.campaign.pictures" />

        <div class="detail-layout__info-wrapper">
            <DetailInfo class="detail-layout__info"
                :lbl="lbl"
                :campaign="detailController.campaign" />

            <DetailAndCondition
                :lbl="lbl"
                :campaign="detailController.campaign" />
        </div>
        
    </div>
</template>
<script>
//helper
import Account from '@/helper/AccountHelper.js';
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
//component
import CampaignPicture from "../detail/Picture.vue";
import DetailInfo from '../detail/DetailInfo.vue';
import DetailAndCondition from "../detail/DetailAndCondition.vue";
export default {
    name: "DefaultLayout",
    mixins: [ErrorApiMixin],
    components: {
        CampaignPicture,
        DetailInfo,
        DetailAndCondition,
    },
    computed: {
        theme: function () {
            return this.$store.state.theme;
        }
    },
    props: {
        lbl: Object,
        locale: Number,
        detailController: Object,
        modalController: Object
    },
    data: function() {
        return {
            isLogin: Account.isLogin(),
            userPoint: Account.getCachePoint()
        };
    },
    created: function () {
        this.errorHandler.setAlertModal(this.modalController.alertModal);
        this.errorHandler.setNoInternetModal(this.modalController.noInternetModal);
    }
};
</script>
<style lang="scss" scoped>
@import "@/module/Detail/component/layout/Layout.scss";
</style>
